import styled from 'styled-components'
import palettes from 'utils/styling/palettes'
import zLayers from 'utils/styling/zLayers'

type CropperOverlayProps = {
  cropLeft: number
  cropTop: number
  cropRight: number
  cropBottom: number
  width: number
  height: number
}

export const CropperOverlay = styled.div<CropperOverlayProps>`
  position: absolute;
  left: ${(props) => props.cropLeft}px;
  top: ${(props) => props.cropTop}px;
  width: ${(props) => props.width - props.cropLeft - props.cropRight}px;
  height: ${(props) => props.height - props.cropTop - props.cropBottom}px;
  pointer-events: none; /* Let events pass through except for handles */
  z-index: ${zLayers.cropper};
`

export const CropHandle = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  background: ${palettes.white.default};
  border: 1px solid ${palettes.brand.default};
  z-index: ${zLayers.cropperHandle};
  pointer-events: auto; /* Allow interaction */
  border-radius: 50%;

  &.left {
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
    cursor: ew-resize;
  }
  &.right {
    right: -5px;
    top: 50%;
    transform: translateY(-50%);
    cursor: ew-resize;
  }
  &.top {
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    cursor: ns-resize;
  }
  &.bottom {
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    cursor: ns-resize;
  }
`
